var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyRoutes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 76,
    viewBox: "0 0 86 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6364 67.7577C17.0188 67.7577 18.3445 67.2086 19.322 66.2311C20.2994 65.2537 20.8486 63.928 20.8486 62.5456C20.8486 61.1633 20.2994 59.8376 19.322 58.8601C18.3445 57.8826 17.0188 57.3335 15.6364 57.3335C14.2541 57.3335 12.9284 57.8826 11.9509 58.8601C10.9734 59.8376 10.4243 61.1633 10.4243 62.5456C10.4243 63.928 10.9734 65.2537 11.9509 66.2311C12.9284 67.2086 14.2541 67.7577 15.6364 67.7577V67.7577Z",
    stroke: "#B4C1D5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9091 31.2729C48.2915 31.2729 49.6172 30.7237 50.5947 29.7463C51.5721 28.7688 52.1213 27.4431 52.1213 26.0608C52.1213 24.6784 51.5721 23.3527 50.5947 22.3752C49.6172 21.3978 48.2915 20.8486 46.9091 20.8486C45.5268 20.8486 44.2011 21.3978 43.2236 22.3752C42.2462 23.3527 41.697 24.6784 41.697 26.0608C41.697 27.4431 42.2462 28.7688 43.2236 29.7463C44.2011 30.7237 45.5268 31.2729 46.9091 31.2729V31.2729Z",
    stroke: "#B4C1D5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2727 62.5454H43C44.1978 62.5454 45.3839 62.3095 46.4905 61.8511C47.5971 61.3927 48.6027 60.7208 49.4496 59.8739C50.2966 59.0269 50.9685 58.0214 51.4269 56.9147C51.8853 55.8081 52.1212 54.622 52.1212 53.4242C52.1212 52.2264 51.8853 51.0403 51.4269 49.9336C50.9685 48.827 50.2966 47.8215 49.4496 46.9745C48.6027 46.1275 47.5971 45.4557 46.4905 44.9973C45.3839 44.5389 44.1978 44.303 43 44.303H22.1515C19.7324 44.303 17.4124 43.342 15.7018 41.6314C13.9913 39.9209 13.0303 37.6009 13.0303 35.1818C13.0303 32.7627 13.9913 30.4426 15.7018 28.7321C17.4124 27.0215 19.7324 26.0605 22.1515 26.0605H31.2727",
    stroke: "#B4C1D5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 54.7273,
    cy: 31.2727,
    r: 31.2727,
    fill: "#B4C1D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyRoutes);
export default __webpack_public_path__ + "static/media/emptyRoutes.dff5c237e453b43231f73ce3b094ac0e.svg";
export { ForwardRef as ReactComponent };